import React from "react";

import { Context } from "../context";
import { Props } from "./types";
import styles from "./styles.scss";

function ScrollZone({ id, orientation = "vertical", children }: Props) {
  const { gutters } = React.useContext(Context);
  const stub = React.useRef<HTMLDivElement | null>(null);
  const foundGutter = gutters.find((g) => g.id === id);
  const track = foundGutter ? foundGutter.ref : stub;
  const root = React.useRef<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (!root.current || !track.current) return;

    const origin = root.current;
    const target = track.current;
    const scrollSensitivity = 1;
    const scroll = (event: WheelEvent) => {
      event.preventDefault();

      const deltaY = event.deltaY * scrollSensitivity;
      const deltaX = event.deltaX * scrollSensitivity;

      if (orientation === "vertical") {
        target.scrollTop += deltaY;
      }

      if (orientation === "horizontal") {
        target.scrollLeft += deltaX;
      }
    };

    origin.addEventListener("wheel", scroll);

    return () => {
      origin.removeEventListener("wheel", scroll);
    };
  }, [id, root.current, track.current, orientation]);

  return (
    <div ref={root} className={styles.scrollZone}>
      {children}
    </div>
  );
}

export { ScrollZone };
